import React from "react";
import WebinarItem from "./WebinarItem.jsx";
import TablePagination from "components/Pagination/TablePagination";
import Headers from "./Headers.jsx";

const WebinarList = ({
  webinars,
  checkedWebinarIds,
  webinar_ids,
  paginationProps,
  onOrderChange,
  query,
}) => {
  return (
    <table>
      <Headers onChange={onOrderChange} value={query.order} />
      {webinars.map((webinar) => (
        <WebinarItem
          webinar={webinar}
          key={webinar.id}
          checkedWebinarIds={checkedWebinarIds}
          webinar_ids={webinar_ids}
        />
      ))}
      <tr>
        <td colSpan="12">
          <TablePagination {...paginationProps} />
        </td>
      </tr>
    </table>
  );
}

WebinarList.defaultProps = {};

WebinarList.propTypes = {};

export default WebinarList;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/AddWebinars/index.jsx